import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import enUS from 'ant-design-vue/es/locale/en_US'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/en'
import moment from 'moment'
import 'moment/dist/locale/zh-cn'
import 'moment/dist/locale/en-gb'
import { EStorageKey } from '/@/types'
import { type AppLocale, isAppLocale } from './index'

const antLocaleMap = {
  'zh-CN': zhCN,
  'en-US': enUS,
} as const

const dayjsLocaleMap: Record<AppLocale, string> = {
  'zh-CN': 'zh-cn',
  'en-US': 'en',
}

const momentLocaleMap: Record<AppLocale, string> = {
  'zh-CN': 'zh-cn',
  'en-US': 'en-gb',
}

export function applyDateLocales (locale: AppLocale) {
  dayjs.locale(dayjsLocaleMap[locale])
  moment.locale(momentLocaleMap[locale])
}

/** 切换语言并同步 Ant Design / dayjs / moment */
export function useAppLocale () {
  const { locale } = useI18n()

  const appLocale = computed({
    get: () => (isAppLocale(locale.value) ? locale.value : 'zh-CN'),
    set: (next: AppLocale) => {
      locale.value = next
      localStorage.setItem(EStorageKey.LANG_CODE, next)
      applyDateLocales(next)
    },
  })

  const antLocale = computed(() => antLocaleMap[appLocale.value])

  applyDateLocales(appLocale.value)

  function setLocale (next: AppLocale) {
    appLocale.value = next
  }

  return {
    locale: appLocale,
    antLocale,
    setLocale,
  }
}
